const threadKey = (item, allowIdFallback = false) => {
  const threadId =
    item?.thread_id ?? (allowIdFallback ? item?.id : undefined);
  return threadId === null || threadId === undefined || threadId === ""
    ? null
    : String(threadId);
};

export const buildMessageSearchResults = (
  reservationResults = [],
  contactResults = [],
  teamResults = [],
) => {
  const seenThreadIds = new Set();
  const teams = (teamResults || []).filter((thread) => {
    const key = threadKey(thread, true);
    if (key === null || seenThreadIds.has(key)) return false;

    seenThreadIds.add(key);
    return true;
  });
  const reservations = [...(reservationResults || [])]
    .sort((previous, next) =>
      (next.check_in || "").localeCompare(previous.check_in || ""),
    )
    .filter((reservation) => {
      const key = threadKey(reservation);
      if (key === null) return true;
      if (seenThreadIds.has(key)) return false;

      seenThreadIds.add(key);
      return true;
    });

  const contacts = (contactResults || []).filter((contact) => {
    const key = threadKey(contact);
    if (key === null || seenThreadIds.has(key)) return false;

    seenThreadIds.add(key);
    return true;
  });

  return { teams, reservations, contacts };
};
